import "./App.css";
import { Routes, Route } from "react-router";
import Home from "./pages/home/home";
import Resume from "./pages/resume/resume";
import PrivacyPolicy from "./pages/privacyPolicy/privacyPolicy";
import AppsPrivacyPolicy from "./pages/appsPrivacyPolicy/appsPrivacyPolicy";

function Application() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/projects" element={<Home />} />
        <Route path="/blogs" element={<Home />} />
        <Route path="/contact#contact" element={<Home />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/apps-privacy-policy.html" element={<AppsPrivacyPolicy />} />
        <Route path="/apps-privacy-policy" element={<AppsPrivacyPolicy />} />
        <Route path="/static/apps-privacy-policy" element={<AppsPrivacyPolicy />} />
        <Route path="/apps-privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </div>
  );
}

export default Application;
